var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-row',[_c('mds-col',[_c('store-provider',_vm._b({attrs:{"is-paged":""},scopedSlots:_vm._u([{key:"default",fn:function({ state: filterUsers }){return [_c('users-table',{attrs:{"users":filterUsers}})]}}])},'store-provider',_vm.$options.storeInfo,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }